import React from 'react';
import {TextField} from '@mui/material';
import styles from './SearchBar.module.css';
import default_theme from 'assets/themes/themes';

const SearchBar = ({ searchQuery, onSearchChange }) => {
    return (
        <div>
            <TextField
                variant="outlined"
                placeholder="Search..."
                value={searchQuery}
                onChange={onSearchChange}
                color= {default_theme.palette.other.tealDark}
                className={styles.searchInput}
            />
        </div>
    );
};

export default SearchBar;
